import React from 'react';
import Sidebar from './Sidebar';
import TopNavbar from './TopNavbar';

const MainWrapper = ({ children, projectId, hideSideBar }) => {
	// console.log('projectId', projectId);
	return (
		<div className='admin-page'>
			{hideSideBar ? null : <Sidebar projectId={projectId} />}
			<div className='admin-body'>
				<TopNavbar />
				<div className='admin-content'>{children}</div>
			</div>
		</div>
	);
};

export default MainWrapper;
